<template>
    <div>



<!-- <app-monev_topbar></app-monev_topbar>
<app-monev_left_sidebar></app-monev_left_sidebar> -->

<section class="content">
<div class="container-fluid">

       <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Instansi/Kantor</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 5%">kode</th>
                            <th class="text-center" style="width: 20%">Nama Kantor</th>
                            <th class="text-center" style="width: 20%">Alamat</th>
                            <th class="text-center" style="width: 10%">Kota</th>
                            <th class="text-center" style="width: 10%">Fax</th>
                            <th class="text-center" style="width: 10%">Telp</th>
                            <th class="text-center" style="width: 10%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" track-by="data.date" :key="data._id">
                            <td class="text-center">{{ index +1}}.</td>
                            <td class="text-center">{{data.kd_kantor}}</td>
                            <td>{{data.nm_kantor}}</td>
                            <td>{{data.al_kantor}}</td>
                            <td>{{data.kota_terbit}}</td>
                            <td class="text-center">{{data.no_faksimili}}</td>
                            <td class="text-center">{{data.no_telpon}}</td>
                            <td class="text-center" >
                                    <!-- <button type="button" class="btn bg-blue btn-xs waves-effect" id="lihat_dokumen">
                                        <i class="material-icons" >search</i>
                                    </button> -->

                                    <button @click="getView(data.id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                    &nbsp;
                                    <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <!-- <button @click="ceksaja">CEK</button> -->
                <!-- <h1>INI</h1>


                <input type="text" class="form-control" placeholder="Pilih Instansi1" id="instansi">
                <input type="text" class="form-control" placeholder="Pilih Instansi" id="id_instansi" >
                <input type="text" class="form-control" placeholder="Pilih Instansi" id="id_ins">


                <h1>INI</h1> -->


                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
&nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
&nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

        <!-- ============================================================ MODAL ======================================================================== -->
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Kanwil</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                    <div class="form-line">
                                        <autocomplete
                                        :url="URL+ 'api/v1/bhumie_kanwil/autocomplete'"
                                        :customHeaders="{authorization: 'kikensbatara '+token }"
                                        anchor="nm_kanwil"
                                        :initValue="nm_kanwil"
                                        :classes="{ input: 'form-control'}"
                                        label="writer"
                                        :onShouldRenderChild="renderChild"
                                        :on-select="getAuto">
                                        </autocomplete>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Kantor</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="nm_kantor" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Alamat</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="al_kantor" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kota</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="kota_terbit" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">No Fax.</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="no_faksimili" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Telp.</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="no_telpon" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                            <button
                            type="button"
                            class="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            >KEMBALI</button>
                        </div>
                        </div>
                    </div>
                </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

            <!-- </div> -->
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <button @click="exit_modal" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Kanwil</label>
                                </div>
                                <div class="col-md-10" v-if="edit_data">
                                    <div class="form-group">
                                    <div class="form-line">
                                        <autocomplete
                                        :url="URL+ 'api/v1/bhumie_kanwil/autocomplete'"
                                        :customHeaders="{authorization: 'kikensbatara '+token }"
                                        anchor="nm_kanwil"
                                        :initValue="nm_kanwil"
                                        :classes="{ input: 'form-control'}"
                                        label="writer"
                                        :onShouldRenderChild="renderChild"
                                        :on-select="getAuto">
                                        </autocomplete>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Kantor</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="nm_kantor" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Alamat</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="al_kantor" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kota</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="kota_terbit" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">No Fax.</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="no_faksimili" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Telp.</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="no_telpon" type="text" id="nilai" class="form-control" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button @click="exit_modal" type="button" class="btn btn-danger waves-effect" data-dismiss="modal" >KEMBALI</button>
                        </div>
                        </div>
                    </div>
                </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
        <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
        </div>
      </div>

        </div>
      </section>
  </div>




</template>


<script>
import Autocomplete from 'vue2-autocomplete-js'
const URL_SERVER = URL_APP;
const URL_DATI2 = URL_APP+'api/v1/bhumie_dati2/';
const ADD_URL = URL_APP+'api/v1/bhumie_kantor/';


export default {
  name: "bhumie_kecamatan",
  components: { Autocomplete },
  data() {
    return {
        id: "",
        kd_kanwil: "",
        nm_kanwil: "",
        kd_kantor: "",
        nm_kantor: "",
        al_kantor: "",
        kota_terbit: "",
        no_faksimili : "",
        no_telpon : "",
        
        edit_data : false,
        list_data: [],
        page_first: 1,
        page_last: 0,
        cari_value: "",
        token : localStorage.token,
        URL : URL_SERVER
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          console.log(data_res);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
            kd_kanwil : this.kd_kanwil,
            kd_kantor : this.kd_kantor,
            nm_kantor : this.nm_kantor,
            al_kantor : this.al_kantor,
            kota_terbit : this.kota_terbit,
            no_faksimili : this.no_faksimili,
            no_telpon : this.no_telpon,

        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
            id : this.id,
            kd_kanwil : this.kd_kanwil,
            kd_kantor : this.kd_kantor,
            nm_kantor : this.nm_kantor,
            al_kantor : this.al_kantor,
            kota_terbit : this.kota_terbit,
            no_faksimili : this.no_faksimili,
            no_telpon : this.no_telpon,
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })
    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(id){
      fetch(ADD_URL+"getView", {
          method : "POST",
          headers : {
              'content-type' : 'application/json',
              authorization : "kikensbatara "+localStorage.token,
          },
          body : JSON.stringify({
              id : id
          })
      }).then(res => res.json())
      .then((res_data)=>{
        //   console.log(res_data);
            this.id = res_data[0].id;
            this.kd_kanwil = res_data[0].kd_kanwil;
            this.nm_kanwil = res_data[0].nm_kanwil;
            this.kd_kantor = res_data[0].kd_kantor;
            this.nm_kantor = res_data[0].nm_kantor;
            this.al_kantor = res_data[0].al_kantor;
            this.kota_terbit = res_data[0].kota_terbit;
            this.no_faksimili = res_data[0].no_faksimili;
            this.no_telpon = res_data[0].no_telpon;

            this.edit_data = true;
      })
    },

    exit_modal : function(){
      this.edit_data = false;
    },


// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    getAuto : function(obj){
      // console.log(obj);
      this.nm_kanwil = obj.nm_kanwil;
      this.kd_kanwil = obj.kd_kanwil;
    },
    renderChild(data) {
        return `
        <span><b>${data.nm_kanwil}</b></span>
        <span style='font-size:80%'>${data.kd_kanwil}</span>
        `
    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    // this.autocompleted();
  },
};
</script>
